<template>
    <div class="col-md-12">
        <div class="col-md-3">
            <label class="control-label"><vue-feather type="user" size="14"></vue-feather> Generales</label>
        </div>
        <!-- Datos personales -->
        <div class="row">            
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label">* RFC</label>
                    <input class="form-control" type="text" placeholder=""
                        v-bind:class="formSubmitted && !validateRFC(store.rfc) ? 'is-invalid' : ''" required="required"
                        v-model="store.rfc">
                    <div class="invalid-feedback">Por favor ingrese un RFC válido (13 caracteres).</div>
                </div>
            </div>      
            <div class="col-md-1">
                <div class="form-group">                         
                    <label class="control-label d-block invisible">Buscar</label>                            
                    <button type="button" class="btn btn-primary ms-2" @click="onSearchRFC">
                        <vue-feather type="search" size="16"></vue-feather>
                    </button>
                </div>
            </div>      
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">CURP</label>
                    <input class="form-control" type="text" placeholder=""
                        v-bind:class="formSubmitted && !store.curp ? 'is-invalid' : ''" required="required"
                        v-model="store.curp" :disabled="store.disabledRFC">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">* Fecha de Nacimiento</label>
                    <input v-model="store.fechaNacimiento" :disabled="store.disabledRFC" class="form-control" type="date" required="required">
                </div>
            </div>         
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">* Nombre(s)</label>
                    <input v-model="store.nombres" :disabled="store.disabledRFC" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">* Apellido Paterno</label>
                    <input v-model="store.apellidoPaterno" :disabled="store.disabledRFC" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label class="control-label">Apellido Materno</label>
                    <input v-model="store.apellidoMaterno" :disabled="store.disabledRFC" class="form-control" type="text" placeholder="" required="required">
                </div>
            </div>            
        </div>        
        <hr />
        <!-- Botón para agregar un domicilio-->
        <div class="row mt-3">
            <!-- Colocar la etiqueta de domicilios y el botón para agregar -->
            <div class="col-md-3">
                <label class="control-label"><vue-feather type="home" size="14"></vue-feather> Domicilios</label>
            </div>
             <!-- Alinear el botón a la derecha -->
            <div class="col-md-9 text-end">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click="onAddDomicilio">
                        <vue-feather type="plus" size="16"></vue-feather>
                    </button>
                </div>
            </div>
        </div>
        
        <!-- Datos de Domicilio -->
        <div v-for="(domicilio, index) in store.domicilios" :key="index">
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p>Domicilio {{ index + 1 }}</p>
                <div>
                    <button type="button" class="btn btn-light btn-sm me-2" @click="onToggleMinimize(index)">
                        <vue-feather :type="domicilio.isMinimized ? 'plus' : 'minus'" size="16"></vue-feather>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" @click="onRemoveDomicilio(index)">
                        <vue-feather type="trash-2" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div v-if="!domicilio.isMinimized">
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label class="control-label">* Tipo de domicilio</label>
                            <!-- Cambiar a select con opciones de tipos de domicilio -->
                            <select v-model="domicilio.tipo" class="form-control" required="required">
                                <option v-for="tipo in store.tiposDomicilios" :key="tipo.id" :value="tipo.id">{{ tipo.nombre }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label class="control-label">* Código Postal</label>
                            <input v-model="domicilio.codigoPostal" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="form-group">                            
                            <label class="control-label d-block invisible">Buscar</label>
                            <button type="button"  class="btn btn-primary btn-sm me-2" @click="onSearchCP(index)">
                                <vue-feather type="search" size="16"></vue-feather>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <label class="control-label">* Estado</label>
                            <input v-model="domicilio.estado" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">* Municipio</label>
                            <input v-model="domicilio.municipio" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Colonia</label>
                            <input v-model="domicilio.colonia" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">* Calle</label>
                            <input v-model="domicilio.calle" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">* Número exterior</label>
                            <input v-model="domicilio.numeroExterior" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                </div>
                <div class="row">                    
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Número interior</label>
                            <input v-model="domicilio.numeroInterior" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Ciudad</label>
                            <input v-model="domicilio.ciudad" :disabled="domicilio.disabledCP" class="form-control" type="text" placeholder="" required="required">
                        </div>
                    </div>
                </div>
            </div>            
        </div>
        <!-- Datos de contacto -->
        <hr />
        <!-- Botón para agregar un contacto-->
        <div class="row mt-3">
            <!-- Colocar la etiqueta de domicilios y el botón para agregar -->
            <div class="col-md-3">
                <label class="control-label"><vue-feather type="mail" size="14"></vue-feather> Medios de contacto</label>
            </div>
             <!-- Alinear el botón a la derecha -->
            <div class="col-md-9 text-end">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click="onAddMedioContacto">
                        <vue-feather type="plus" size="16"></vue-feather>
                    </button>
                </div>
            </div>
        </div>

        <!-- Datos de Medio de contacto -->
        <div v-for="(medio, index) in store.mediosContacto" :key="index">
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p>Medio de contacto {{ index + 1 }}</p>
                <div>
                    <button type="button" class="btn btn-light btn-sm me-2" @click="onToggleMinimizeMedioContacto(index)">
                        <vue-feather :type="medio.isMinimized ? 'plus' : 'minus'" size="16"></vue-feather>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" @click="onRemoveMedioContacto(index)">
                        <vue-feather type="trash-2" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div v-if="!medio.isMinimized" class="row mt-3">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">* Tipo</label>
                        <select v-model="medio.tipo" class="form-control" required="required">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option v-for="tipo in store.tiposMediosContacto" :key="tipo.medioId" :value="tipo.medioId">{{ tipo.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">* Contacto</label>
                        <input v-model="medio.valor" class="form-control" type="text" placeholder="" required="required">
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Datos financieros -->
        <hr />
        <div class="row mt-3">
            <div class="col-md-3">
                <label class="control-label"><vue-feather type="dollar-sign" size="14"></vue-feather> Datos Financieros</label>
            </div>
            <div class="col-md-9 text-end">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click="onAddCuentaBancaria">
                        <vue-feather type="plus" size="16"></vue-feather>
                    </button>
                </div>
            </div>
        </div>

        <div v-for="(cuenta, index) in store.informacionFinanciera" :key="index">
            <div class="d-flex justify-content-between align-items-center mt-3">
                <p>Cuenta Bancaria {{ index + 1 }}</p>
                <div>
                    <button type="button" class="btn btn-light btn-sm me-2" @click="onToggleMinimizeCuentaBancaria(index)">
                        <vue-feather :type="cuenta.isMinimized ? 'plus' : 'minus'" size="16"></vue-feather>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm" @click="onRemoveCuentaBancaria(index)">
                        <vue-feather type="trash-2" size="16"></vue-feather>
                    </button>
                </div>
            </div>
            <div v-if="!cuenta.isMinimized" class="row mt-3">                
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">* Tipo de instrumento</label>
                        <select v-model="cuenta.instrumento" class="form-control" required="required">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option v-for="instrumento in store.instrumentos" :key="instrumento.id" :value="instrumento.id">{{ instrumento.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">* Institución bancaria</label>
                        <select v-model="cuenta.banco" class="form-control" required="required">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option v-for="banco in store.bancos" :key="banco.id" :value="banco.id">{{ banco.nombre }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">* Número de cuenta</label>
                        <input v-model="cuenta.cuenta" class="form-control" type="text" placeholder="" required="required">
                    </div>
                </div>
            </div>
        </div>

        <!-- Fin de datos financieros -->
        <hr class="mt-3" />
            <div class="mt-3 col-md-12">
                <p><b>* Campos obligatorios</b></p>
            </div>
            <!--
            <div class="mt-3 col-md-12">
                <button class="btn btn-primary float-end" @click="savePersonales">Guardar y continuar</button>
            </div>
            -->
        </div>                      
    

</template>

<script>
import api from '@/axios';
import { fetchAllItems } from '@/utils/listResponse';
import { useSeguroStore } from '@/stores/seguroStore';

export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            errors: [],                     
        };
    },
    mounted() {        
        this.fetchBancos(); // Fetch bank options when the component is mounted
        this.fetchInstrumentos(); // Fetch instrument options when the component is mounted
        this.fetchOrganizaciones(); // Fetch organization options when the component is mounted
        this.fetchUnidades(); // Fetch unit options when the component is mounted
        this.fetchTiposDomicilios(); // Fetch domicile type options when the component is mounted
        this.fetchTiposMedios(); // Fetch contact medium type options when the component is mounted
        this.fetchEnrollers(); // Fetch enroller options when the component is mounted
    },
    methods: {
        async fetchBancos() {
            try {
                this.loading = true;
                this.error = null;
                this.store.bancos = (await fetchAllItems("bancos")).items;
            } catch (err) {                
                this.error = 'No se pudieron cargar los Bancos.';
            } finally {
                this.loading = false;
            }
        },
        async fetchInstrumentos() {
            try {
                this.loading = true;
                this.error = null;
                this.store.instrumentos = (await fetchAllItems("instrumentos")).items;
            } catch (err) {                
                this.error = 'No se pudieron cargar los Instrumentos.';
            } finally {
                this.loading = false;
            }
        },
        async fetchOrganizaciones() {
            try {
                this.loading = true;
                this.error = null;
                this.store.organizaciones = (await fetchAllItems("organizaciones")).items.map(item => ({ id: item.id, nombre: item.nombre }));
            } catch (err) {
                this.error = 'No se pudieron cargar las Organizaciones.';
            } finally {
                this.loading = false;
            }
        },
        async fetchUnidades() {
            try {
                this.loading = true;
                this.error = null;
                this.store.unidades = (await fetchAllItems("unidades")).items.map(item => ({ id: item.id, nombre: item.nombre }));
            } catch (err) {
                this.error = 'No se pudieron cargar las Unidades.';
            } finally {
                this.loading = false;
            }
        },
        async fetchTiposDomicilios() {
            try {
                this.loading = true;
                this.error = null;
                this.store.tiposDomicilios = (await fetchAllItems("tiposdomicilios")).items;
            } catch (err) {                
                this.error = 'No se pudieron cargar los Tipos de Domicilios.';
            } finally {
                this.loading = false;
            }
        },
        async fetchTiposMedios() {
            try {
                this.loading = true;
                this.error = null;
                this.store.tiposMediosContacto = (await fetchAllItems("tiposmedios")).items;
            } catch (err) {                
                this.error = 'No se pudieron cargar los Tipos de Medios de Contacto.';
            } finally {
                this.loading = false;
            }
        },
        async fetchEnrollers() {
            try {
                this.loading = true;
                this.error = null;
                this.store.enrollers = (await fetchAllItems("usuarios/rol/enroller")).items.map(item => ({ id: item.id, nombre: item.informacionPersonal.nombre }));
            } catch (err) {                
                this.error = 'No se pudieron cargar los Enrollers.';
            } finally {
                this.loading = false;
            }
        },          
        onSubmit() {
            this.formSubmitted = true;
            this.errors = [];
            if (
                (this.firstname.length < 3 || this.firstname > 10) &&
                (this.lastname.length < 3 || this.lastname.length > 10)
            ) {
                this.firstError = true;
                this.lastError = true;
                this.errors.push({});
            } else {
                this.firstError = false;
                this.lastError = false;
                this.errors.push({});
            }
        },
        onAddFinanciera() {
            // Logic to add financial institution
            alert("Agregar institución financiera");
            // Agregar al formulario un bloque de datos financieros

        },
        onAddDomicilio() {
            if (!Array.isArray(this.store.domicilios)) {
                this.store.domicilios = [];
            }
            this.store.domicilios.push({
                codigoPostal: '',
                estado: '',
                municipio: '',
                colonia: '',
                calle: '',
                ciudad: '',
                numeroExterior: '',
                numeroInterior: '',
                disabledCP: 1,
                isMinimized: false,
            });
        },
        async onSearchRFC() {
            try {
                this.loading = true;
                this.error = null;                
                const response = await api.get(`informacionpersonal/rfc/${this.store.rfc}`);
                if (response.status === 200) {
                    this.store.curp = response.data.curp;
                    this.store.fechaNacimiento = new Date(response.data.fechaNacimiento).toISOString().split('T')[0];
                    this.store.nombres = response.data.nombre;
                    this.store.apellidoPaterno = response.data.paterno;
                    this.store.apellidoMaterno = response.data.materno;
                    this.store.disabledRFC = 0;
                }
            } catch (err) {
                this.store.curp = "";                    
                this.store.fechaDeNacimiento = null;                
                this.store.nombres = "";
                this.store.apellidoPaterno = "";
                this.store.apellidoMaterno = "";
                this.store.disabledRFC = 0;                
            } finally {
                this.loading = false;
            }
        },
        async onSearchCP(index) {
            try {
                this.loading = true;
                this.error = null;
                const domicilio = this.store.domicilios[index];                
                const response = await api.get(`codigospostales/porcodigo/${domicilio.codigoPostal}`);
                if (response.status === 200) {
                    domicilio.estado = response.data.municipios.estados.nombre;
                    domicilio.municipio = response.data.municipios.nombre;
                    domicilio.colonia = response.data.nombreAsentamiento;
                    domicilio.ciudad = response.data.ciudades.nombre;
                    domicilio.disabledCP = 0;
                }
            } catch (err) {
                // Opcional: resetear solo este domicilio
                const domicilio = this.store.domicilios[index];
                domicilio.estado = "";
                domicilio.municipio = "";
                domicilio.colonia = "";
                domicilio.ciudad = "";
                domicilio.disabledCP = 0;
            } finally {
                this.loading = false;
            }
        },
        async savePersonales() {
            try {
                this.loading = true;
                this.error = null;
                const response = await api.get(`informacionpersonal/rfc/${this.store.rfc}`);
                if (response.status === 200) {
                    this.store.contratanteId = response.data.id;
                    // Actualizar información existente
                    await api.put(`informacionpersonal/${this.store.contratanteId}`, {
                        RFC: this.store.rfc,
                        CURP: this.store.curp,
                        Nombre: this.store.nombres,
                        Paterno: this.store.apellidoPaterno,
                        Materno: this.store.apellidoMaterno,
                        FechaNacimiento: this.store.fechaNacimiento,
                    });
                } else {
                    // Crear nueva información
                    const createResponse = await api.post('informacionpersonal', {
                        RFC: this.store.rfc,
                        CURP: this.store.curp,
                        Nombre: this.store.nombres,
                        Paterno: this.store.apellidoPaterno,
                        Materno: this.store.apellidoMaterno,
                        FechaNacimiento: this.store.fechaNacimiento,
                    });
                    this.store.contratanteId = createResponse.data.id;
                }                // Guardar domicilios
                for (const domicilio of this.store.domicilios) {
                    await api.post('domicilios', {
                        ...domicilio,
                        contratanteId: this.store.contratanteId
                    });
                }
                // Guardar medios de contacto
                for (const medio of this.store.mediosContacto) {
                    await api.post('medioscontacto', {
                        ...medio,
                        contratanteId: this.store.contratanteId
                    });
                }
                // Guardar cuentas bancarias
                for (const cuenta of this.store.informacionFinanciera) {
                    await api.post('cuentasbancarias', {
                        ...cuenta,
                        contratanteId: this.store.contratanteId
                    });
                }
                
                await api.put(`polizas/${this.store.folio}`, {
                    contratanteId: this.store.contratanteId
                });              
            }
            catch (err) {
                this.error = 'No se pudo guardar la información personal.';
            } finally {
                this.loading = false;
            }
            this.$emit('nextTab'); // Emitir evento para que el wizard avance al siguiente tab
        },
        async fetchPersonales() {
            if (this.store.rfc == null || this.store.rfc == '') {
                return;
            }
            if (this.store.rfc != '') {
                try {
                    this.loading = true;
                    this.error = null;                
                    const response = await api.get(`informacionpersonal/rfc/${this.store.rfc}`);
                    if (response.status === 200) {
                        this.store.curp = response.data.curp;
                        this.store.fechaNacimiento = new Date(response.data.fechaNacimiento).toISOString().split('T')[0];
                        this.store.nombres = response.data.nombre;
                        this.store.apellidoPaterno = response.data.paterno;
                        this.store.apellidoMaterno = response.data.materno;
                        this.store.disabledRFC = 0;
                    }
                } catch (err) {                
                    this.store.resetContratante();
                } finally {
                    this.loading = false;
                }
            }
        },
        // Función que valida los 13 caracteres del RFC
        validateRFC(rfc) {
            const rfcPattern = /^([A-ZÑ&]{3,4})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([A-Z\d]{3})$/;
            return rfcPattern.test(rfc);
        },
        onSearchRFCWithValidation() {
            if (!this.validateRFC(this.store.rfc)) {
                this.error = 'RFC inválido. Por favor, ingrese un RFC válido.';
                return;
            }
            this.onSearchRFC();
        },
        onRemoveDomicilio(index) {
            this.store.domicilios.splice(index, 1);
        },
        onToggleMinimize(index) {
            const domicilio = this.store.domicilios[index];
            domicilio.isMinimized = !domicilio.isMinimized;
        },
        onAddMedioContacto() {
            if (!Array.isArray(this.store.mediosContacto)) {
                this.store.mediosContacto = [];
            }
            this.store.mediosContacto.push({
                tipo: '',
                valor: '',
                isMinimized: false,
            });
        },
        onRemoveMedioContacto(index) {
            this.store.mediosContacto.splice(index, 1);
        },
        onToggleMinimizeMedioContacto(index) {
            const medio = this.store.mediosContacto[index];
            medio.isMinimized = !medio.isMinimized;
        },
        onAddCuentaBancaria() {
            if (!Array.isArray(this.store.informacionFinanciera)) {
                this.store.informacionFinanciera = [];
            }
            this.store.informacionFinanciera.push({
                banco: '',
                instrumento: '',
                cuenta: '',
                isMinimized: false,
            });
        },
        onRemoveCuentaBancaria(index) {
            this.store.informacionFinanciera.splice(index, 1);
        },
        onToggleMinimizeCuentaBancaria(index) {
            const cuenta = this.store.informacionFinanciera[index];
            cuenta.isMinimized = !cuenta.isMinimized;
        },
    }
}
</script>